const baseTheme = {
  fonts: {
    mono: '"SF Mono", "Roboto Mono", Menlo, monospace',
  },
}

const lightTheme = {
  ...baseTheme,
  colors: {
    background: '#fff',
    code: '#bbbbbb',
    heading: '#000',
    text: '#3B454E',
    preFormattedText: 'rgb(245, 247, 249)',
    link: '#1000EE',
  },
}

const darkTheme = {
  ...baseTheme,
  colors: {
    background: '#001933',
    code: '#323232',
    heading: '#fff',
    text: '#fff',
    preFormattedText: '#000',
    link: '#1ED3C6',
  },
}

export { lightTheme, darkTheme }
